import request from '@/utils/request.js'

export function scenicList(params) {
  return request({
    url: '/scenic/list',
    method: 'get',
    params: params
  })
}

export function scenicInfo(params) {
  return request({
    url: '/scenic/info',
    method: 'get',
    params: params
  })
}
